import { render, staticRenderFns } from "./LastUpdateUserBox.vue?vue&type=template&id=4eba3c42&scoped=true&lang=pug"
import script from "./LastUpdateUserBox.vue?vue&type=script&lang=js"
export * from "./LastUpdateUserBox.vue?vue&type=script&lang=js"
import style0 from "./LastUpdateUserBox.vue?vue&type=style&index=0&id=4eba3c42&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba3c42",
  null
  
)

export default component.exports